import * as React from 'react';
import { useState } from 'react';
import {
  NODE_PARAGRAPH,
  render,
  MARK_LINK,
} from 'storyblok-rich-text-react-renderer';

import { storyblokEditable } from 'gatsby-source-storyblok';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
  Virtual, Thumbs, FreeMode, EffectCards, Mousewheel
} from 'swiper';
import FancyTitle from '../fancy-title';

// eslint-disable-next-line import/no-unresolved
import 'swiper/css';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/virtual';
import LinkResolver from '../../helpers/link-resolver';
import History from '../history';

export default function HistorySection({ blok }) {
  const [swiper, setSwiper] = useState(null);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const slideTo = (index) => {
    if (!swiper || swiper.destroyed) {
      return;
    }
    swiper.slideTo(index);
    setActiveIndex(index);
  };

  const handleSlideChange = (swiperCore) => {
    const { activeIndex: _activeIndex } = swiperCore;
    setActiveIndex(_activeIndex);
    if (!thumbsSwiper || thumbsSwiper.destroyed) {
      return;
    }
    thumbsSwiper.slideTo(_activeIndex);
  };

  const activeYearClass = `
    relative
    w-fit
    font-bold
    before:content-[attr(before)]
    before:h-[4px]
    before:bg-latori-pink
    before:rounded
    before:!w-full
    before:absolute
    before:-bottom-0
    before:transition
    before:transition-width
    `;
  return (
    <div {...storyblokEditable(blok)} className="lg:text-center flex flex-col lg:pr-16 py-8 lg:py-0">
      <History
        title=""
        subtitle=""
        items={blok.years}
      />
    </div>
  );
}
